const en = {
    //login
    greeting: "If you spend more than you earn, you'll always be poor.",
    username: "Username:",
    registration: "REGISTRATION",
    log_required: "required",
    pass: "Password:",
    in: "LOGIN",
    //registration
    required: "required",
    bevare_name_length: "Username must be at least 4 characters long.",
    bevare_name_matches: "Username can only contain latin letters and numbers.",
    bevare_pass_length: "Password must be at least 4 characters long.",
    bevare_pass_matches: "Password can only contain latin letters and numbers.",
    bevare_pass_check: "Passwords do not match.",
    reg_pass: "Password:",
    reg_to_log: "LOGIN",
    check_pass: "Repeat password:",
    reg_button: "REGISTER",
    reg_username: "Username:",
    //logined
    logined_trans_button_text: "Add",
    logined_trans_list: "TRANSACTION LIST:",
    //navbar
    new_transaction: "new transaction",
    transaction_statistic: "transaction statistics",
    transaction_history: "transaction history",
    calc: "calculator",
    //transaction
    transaction_date: "Date:",
    transaction_amount: "Amount:",
    transaction__details: "Details:",
    //transaction form
    tf_data: "Date:",
    tf_type: "Type:",
    tf_expence: "Expense",
    tf_income: "Income",
    tf_placeholder_target: "Expense target",
    tf_placeholder_amount: "Amount",
    tf_error: "Unfortunately, the action failed. Please try again later.",
    tf_complite: "Entry added",
    //edit transaction
    et_update: "update",
    et_cancel: "cancel",
    //delete transaction
    dt_delete: "Do you want to delete this entry?",
    dt_error: "Unfortunately, deletion failed, please try again later.",
    dt_complite: "Record deleted",
    //transaction controls
    tr_contrl_oldbegin: "Oldest first",
    tr_contrl_newbegin: "Newest first",
    tr_contrl_reload: "Reload data",
    tr_contrl_find: "Search transaction type",
    //summary
    sum_total_income: "Total income:",
    sum_total_expence: "Total expenses:",
    sum_total_remain: "Remaining:",
    sum_search_in_budget: "Search expenses:",
    sum_search: "Search",
    sum_summary_expenses_bytype: "Total expenses by type:",
    expence_by_month: "Expenses by month",

};

export default en;